import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
	DividerComponent,
	HeadlineComponent,
	IconModule,
	MobileSubNavListEntryComponent,
	NavListModule,
	SubNavModule,
	TagComponent,
	TooltipModule,
} from '@agilox/ui';
import { AppBackgroundPipe } from './app-nav/app-background-pipe/app-background.pipe';
import { AppNavComponent } from './app-nav/app-nav.component';
import { MobileAppNavComponent } from './mobile-app-nav/mobile-app-nav.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { NavComponent } from './nav/nav.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		IconModule,
		MatIconModule,
		NavListModule,
		SubNavModule,
		TooltipModule,
		HeadlineComponent,
		DividerComponent,
		MobileSubNavListEntryComponent,
		TagComponent,
		AppBackgroundPipe,
	],
	declarations: [MobileNavComponent, NavComponent, AppNavComponent, MobileAppNavComponent],
	exports: [MobileNavComponent, NavComponent, AppNavComponent, MobileAppNavComponent],
})
export class NavModule {}
